var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileUploadScan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 8,
    fill: "#155EEF",
    fillOpacity: 0.07
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.7366 10.7618H15.0846C13.0046 10.7538 11.3006 12.4108 11.2506 14.4908V25.2278C11.2056 27.3298 12.8736 29.0698 14.9746 29.1148C15.0116 29.1148 15.0486 29.1158 15.0846 29.1148H23.0726C25.1626 29.0408 26.8146 27.3188 26.8026 25.2278V16.0378L21.7366 10.7618Z",
    stroke: "#155EEF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4749 10.7501V13.6591C21.4749 15.0791 22.6239 16.2301 24.0439 16.2341H26.7979",
    stroke: "#155EEF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6409 17.9088V23.9498",
    stroke: "#155EEF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9866 20.2643L18.6416 17.9093L16.2966 20.2643",
    stroke: "#155EEF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileUploadScan);
export default __webpack_public_path__ + "static/media/file-upload-scan.e7047968a13f13b79a75d047824ba9a3.svg";
export { ForwardRef as ReactComponent };